export default __webpack_public_path__ + "static/topic5-3bba88f21763bfa4ff5c597660805d7f.png";